import { useTranslation } from "react-i18next";
import {
  translationConstants,
  paymentType,
  Directions,
} from "../../../constants";
import { useSelector } from "react-redux";

const PricingModal = (props) => {
  const { t } = useTranslation();
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  return (
    <div className="freelance-instructor-model-sm">
      <p className="pricing-heading mt-3">
        {t(translationConstants.PRICING_BREAKDOWN)}
      </p>
      <hr />
      <div className="d-flex justify-content-between mt-4">
        <p className="subscritption">
          {(props?.isCenterSubscription ||
            props?.isMembership ||
            props?.isFreelanceSubscription) && (
            <>
              {t(translationConstants.SUBSCRITION_FEE)}
              <span>({t(translationConstants.YEARLY)})</span>
            </>
          )}
          {props?.isEventCompetition &&
            (props?.type === paymentType.Event
              ? t(translationConstants.EVENT_FEE)
              : t(translationConstants.COMPETITION_FEE))}
        </p>
        <span className="sar">({translationConstants.SAR})</span>
      </div>

      {props?.isMembership && (
        <>
          <div className="d-flex justify-content-between pt-2">
            <p>{t(translationConstants.Membership_Fees)}</p>
            <p>{props?.data?.subTotal}</p>
          </div>
          <hr />
        </>
      )}

      {props?.isEventCompetition && (
        <>
          <div className="d-flex justify-content-between pt-2">
            <p>
              {props?.type === paymentType.Event
                ? direction === Directions.rtl && props?.eventData?.arabicTitle
                  ? props?.eventData?.arabicTitle
                  : props?.eventData?.title
                : direction === Directions.rtl &&
                  props?.competitionData?.arabicTitle
                ? props?.competitionData?.arabicTitle
                : props?.competitionData?.title}
            </p>
            <p>{props?.data?.subTotal}</p>
          </div>
          <hr />
        </>
      )}

      {props?.isCenterSubscription &&
        props?.data?.locations?.map((location) => (
          <>
            <div className="mt-3">
              <p className="font-weight-700">{location?.name}</p>
            </div>
            {location?.sports?.map((sport) => (
              <>
                <div className="d-flex justify-content-between">
                  <p>{t(sport.name)}</p>
                  <p>{sport.price}</p>
                </div>
                <hr />
              </>
            ))}
          </>
        ))}

      <div className="mt-3">
        <div className="d-flex justify-content-between w-100">
          <div>
            <p className="footer-text">{t(translationConstants.SUB_TOTAL)}</p>
          </div>
          <div>
            <p className="footer-text">{props?.data?.subTotal}</p>
          </div>
        </div>
        <div className="d-flex justify-content-between w-100">
          <div>
            <p className="footer-text">
              {t(translationConstants.VAT)}{" "}
              <span dir={Directions.ltr}>({props?.data?.vat}%)</span>
            </p>
          </div>
          <div>
            <p className="footer-text">{props?.data?.vatValue?.toFixed(2)}</p>
          </div>
        </div>
        <div className="d-flex justify-content-between w-100">
          <div>
            <p className="footer-text">{t(translationConstants.TOTAL_FEE)}</p>
          </div>
          <div>
            <p className="footer-text">{props?.data?.totalFees?.toFixed(2)}</p>
          </div>
        </div>
      </div>

      <div className="text-center mt-3 font-8">
        {`${t(translationConstants.VAT)}: ${process.env.REACT_APP_VAT_NO}`}
      </div>
    </div>
  );
};

export default PricingModal;
